export default {
  "container": "_container_10nu08"
};
